/**
 * The type PromiseResult<T> is an alias to PromiseSettledResult<T>
 *
 *
 * @alias PromiseSettledResult<T>
 * @public
 */

export type PromiseResult<T> = PromiseSettledResult<T>;

/**
 * The type Fulfilled<T> is an alias to PromiseFulfilledResult<T>
 *
 *
 * @alias PromiseSettledResult<T>
 * @public
 */
export type Fulfilled<T> = PromiseFulfilledResult<T>;
/**
 * The type Rejected is an alias to PromiseRejectedResult.
 *
 *
 * @alias PromiseSettledResult<T>
 * @public
 */
export type Rejected = PromiseRejectedResult;

// TASK LIST: [TODO: Types] (Review Documentation) -------------------
